import { Fragment } from "react"
import { ModalidadGrupoTarifa, RentaTarifa, TipoAlojamientoGrupoTarifa } from "src/gql/schema"
import Detail from "src/shared/components/data-display/Detail/Detail"
import DetailContent from "src/shared/components/data-display/Detail/kit/DetailContent/DetailContent"
import DetailIcon from "src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { sum } from "src/shared/helpers/calculator"
import { groupRentasTarifasByTarifa } from "src/shared/helpers/groupRentasTarifasByTarifa"
import { useDate } from "src/shared/hooks/useDate"
import { capitalize } from "src/shared/helpers/capitalize"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import EntradaMotel from "./sections/EntradaMotel"

const DetailEstancia = ({ rentas_tarifas }: { rentas_tarifas: RentaTarifa[] }) => {
    const { diffDays } = useDate()
    const grupos = groupRentasTarifasByTarifa(rentas_tarifas)
    const { formatCustomDate, setStartDate } = useFormatDate()

    return (
        <Detail color='var(--tipografa)'>
            <DetailIcon name='BedFilled' />
            <DetailContent>
                <DetailRow>
                    <DetailText type='normal'>Estancia</DetailText>
                    <DetailText textAlign="right" type='normal'>
                        {formatCurrencyToFixed(sum(grupos.map((rt) => rt.total || 0)))}
                    </DetailText>
                </DetailRow>
                {grupos.map((rt, idx) => {
                    const esMotel = rt.tarifa?.grupo_tarifa?.tipo_alojamiento === TipoAlojamientoGrupoTarifa.Motel

                    if (esMotel) {
                        return (
                            <Fragment key={`rt-${idx}`}>
                                <EntradaMotel grupo={rt} />
                            </Fragment>
                        )
                    }

                    return (
                        <Fragment key={`rt-${idx}`}>
                            <DetailRow>
                                {
                                    rt.tarifa?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base ?
                                        <DetailText type='bold'>{capitalize(rt.tarifa?.grupo_tarifa?.modalidad)}</DetailText> :
                                        <DetailText type='bold'>{capitalize(rt.tarifa?.grupo_tarifa?.modalidad || "")} - {rt.tarifa?.grupo_tarifa?.nombre || ""}</DetailText>
                                }
                            </DetailRow>
                            <DetailRow>
                                <DetailText type='bold'>
                                    {sum(rt.entradas.map((e) => e.subtotales?.noches || 0))} noches
                                </DetailText>
                            </DetailRow>
                            {rt.entradas.map((entry, index) => {
                                const inicio = setStartDate(entry.fecha_inicio)
                                const fin = setStartDate(entry.fecha_fin)
                                const inicioFormatted = formatCustomDate(inicio, "MMM, DD")
                                const finFormatted = formatCustomDate(fin, "MMM, DD")
                                return (
                                    <DetailRow key={`entry-${index}`}>
                                        <DetailText>
                                            {diffDays(inicio, fin) >= 1
                                                ? `${inicioFormatted}-${finFormatted}`
                                                : inicioFormatted
                                            }
                                        </DetailText>
                                        <DetailText type="bold" textAlign="right" style={{ maxWidth: "90px" }}>
                                            {formatCurrencyToFixed(entry.subtotales?.total || 0)}
                                        </DetailText>
                                    </DetailRow>
                                )
                            })}
                        </Fragment>
                    )
                })}
            </DetailContent>
        </Detail>
    )
}

export default DetailEstancia
